import React from "react";

const Groups: React.FC = () => {
  return <>GROUPS PAGE</>;
};

export default Groups;
